export const APPROVE_WALLET_TRANSACTION_START =
  'APPROVE_WALLET_TRANSACTION_START';
export const APPROVE_WALLET_TRANSACTION_ERROR =
  'APPROVE_WALLET_TRANSACTION_ERROR';
export const APPROVE_WALLET_TRANSACTION_SUCCESS =
  'APPROVE_WALLET_TRANSACTION_SUCCESS';
export const APPROVE_WALLET_TRANSACTION_RESET =
  'APPROVE_WALLET_TRANSACTION_RESET';
